// ru.js
const RU = {
    type: "RU",
    lang: "Русский язык",

    // 首页-页眉字符
    index_1: "Главная",
    index_2: "О нас",
    index_3: "О компании",
    index_4: "Награды и сертификаты",
    index_5: "Корпоративная культура",
    index_6: "Продукты",
    index_7: "Новости",
    index_8: "Поддержка",
    index_9: "Сотрудничество",
    index_10: "Послепродажный сервис",
    index_11: "Загрузки",
    index_12: "Горячая линия",
    // 首页-主体字符
    index_23: "Свяжитесь с нами",
    index_24_1: "Телефон: 15910967510",
    index_25_1: "Email: andaf@sina.com",
    index_27_1: "Адрес: ",
    index_28_1: "F6-3, Центр развития технологий Синьфэйда, р-н Шахэ, Чанпин, Пекин",

    // 首页-页脚字符
    foot_1: "Почему выбирают Pascal",
    foot_2: "Последние продукты",
    foot_6: "Отправить",
    foot_7: "Официальный WeChat",
    foot_8: "Мобильная версия",

    // 手机底部导航栏
    mobile_foot1: "Главная",
    mobile_foot2: "Продукты",
    mobile_foot3: "Новости",
    mobile_foot4: "Документы",

    // 首页-关于我们模块
    home_about_title: "Pascal Technology",
    home_about_subtitle: "Освоение ключевых технологий в области флюидов",
    home_about_description: "ООО «Паскаль (Пекин) Флюидные технологии» — высокотехнологичная компания, занимающаяся разработкой оборудования и комплектующих для медицинской, биологической и научно-приборостроительной отраслей. Руководствуясь принципами честности, профессионализма и эффективности, компания непрерывно развивает ключевые технологии в области флюидов, предлагая клиентам высококачественные продукты и услуги. Ассортимент продукции — ультраточные шприцевые насосы, плунжерные насосы, насосы высокого давления, обратные клапаны, ротационные клапаны, фильтры, трубопроводы и фитинги — получил единодушное признание за передовые технологии и высокое качество. Компания располагает сильной командой R&D и первоклассным шлифовально-полировальным оборудованием для выполнения индивидуальных заказов и предоставления комплексных решений в области флюидных компонентов.",
    home_about_more: "Подробнее +",
    home_about_stat1_value: "10",
    home_about_stat1_unit: "лет+",
    home_about_stat1_label: "Лет в сфере флюидных технологий",
    home_about_stat2_value: "50",
    home_about_stat2_unit: "+",
    home_about_stat2_label: "Собственных прецизионных продуктов",
    home_about_stat3_value: "300",
    home_about_stat3_unit: "+",
    home_about_stat3_label: "Клиентов по всему миру",

    // 其他页面
    text1: "Введите содержимое",
    text2: "Загружается...",
    text3: "Проконсультироваться",
    text4: "Название компании",
    text5: "Название продукта",
    text6: "Контактная информация",
    text7: "Примечания",
    text8: "Мы принимаем обращения по телефону, электронной почте и стационарному телефону. Свяжемся с вами в ближайшее время.",
    text10: "Подробности продукта",
    text11: "Документация",
    consultation_tag: "Консультация",
    consultation_page_title: "Почему выбирают нас",
    consultation_subtitle: "Для задач точного управления потоками мы уделяем внимание точности деталей, подбору материалов и стабильности работы, чтобы быстрее подобрать подходящее решение.",
    consultation_advantage_1_title: "Точная обработка",
    consultation_advantage_1_desc: "У нас есть опыт микронной прецизионной обработки с акцентом на стабильность критических размеров и сборки.",
    consultation_advantage_2_title: "Подбор материалов",
    consultation_advantage_2_desc: "Мы работаем с керамикой, инженерными пластиками и другими материалами и можем рекомендовать решения с учетом среды и требований к коррозионной стойкости.",
    consultation_advantage_3_title: "Прикладной опыт",
    consultation_advantage_3_desc: "Опираясь на опыт OEM-оборудования и реальных условий эксплуатации, мы помогаем быстрее подтвердить подходящее решение.",
    consultation_info_tag: "Что важно",
    consultation_info_title: "Расскажите о вашем сценарии применения и потребностях, и мы быстрее подберем подходящее решение",
    consultation_focus_1_title: "Сценарий применения",
    consultation_focus_1_desc: "Укажите тип среды, модель оборудования, диапазон расхода или давления, чтобы быстрее оценить подходящее решение.",
    consultation_focus_2_title: "Направление продукта",
    consultation_focus_2_desc: "Если у вас уже есть целевой продукт, модель или задача по замене, укажите это, и мы сверим запрос с текущей линейкой продукции.",
    consultation_focus_3_title: "Требования к поставке",
    consultation_focus_3_desc: "Если важны образцы, сроки поставки или кастомизация, лучше отметить это заранее, чтобы подключить нужного специалиста.",
    consultation_helper: "После отправки мы свяжемся с вами как можно скорее и обсудим рекомендации с учетом реальных условий работы.",
    consultation_form_tag: "Онлайн-форма",
    consultation_form_title: "Оставьте данные для консультации",
    consultation_form_desc: "Чем подробнее информация, тем точнее рекомендация будет соответствовать вашей задаче.",
    consultation_prefill: "Текущий продукт",
    consultation_company_label: "Название вашей компании",
    consultation_company_placeholder: "Введите название компании или организации",
    consultation_product_label: "Какой продукт вас интересует",
    consultation_product_placeholder: "Введите название продукта, модель или направление применения",
    consultation_contact_label: "Ваши контакты",
    consultation_contact_placeholder: "Укажите телефон, email или WeChat для быстрого ответа",
    consultation_requirement_label: "Дополнительные требования",
    consultation_requirement_placeholder: "Можно указать тип среды, условия работы, срок поставки или требования к кастомизации",
    consultation_submit: "Отправить запрос",
    consultation_submit_error: "Не удалось отправить запрос. Попробуйте позже.",

}
export default RU
